// @migration-in-progress
/**
 * Pre-Departure Check Data - Weather and Engine Requirements
 * Separated from main requirements file for ESLint compliance
 */

// ENGINE CHECKS - Empty since engine test is now in universal checks
export const ENGINE_CHECKS = [];

// WEATHER CHECKS - Empty array since weather forecast is handled in conditional checks
// (Only required for Cat 0-4 vessels per WBC3 Section 19)
export const WEATHER_CHECKS = [];

/**
 * Check if a trigger condition is met
 */
export function checkTrigger(trigger, vesselConfig) {
  switch (trigger.type) {
    case 'type':
      return vesselConfig.type === trigger.condition;
      
    case 'personsCapacity':
      const capacity = vesselConfig.personsCapacity || vesselConfig.maxPersons || 0;
      if (trigger.condition.startsWith('>')) {
        return capacity > parseInt(trigger.condition.slice(1));
      }
      return capacity >= parseInt(trigger.condition);
      
    case 'grossTonnage':
      const tonnage = vesselConfig.grossTonnage || 0;
      if (trigger.condition.startsWith('>=')) {
        return tonnage >= parseInt(trigger.condition.slice(2));
      }
      return tonnage > parseInt(trigger.condition);
      
    case 'length':
      const length = vesselConfig.lengthOverall || 0;
      if (trigger.condition.startsWith('>=')) {
        return length >= parseInt(trigger.condition.slice(2));
      }
      return length > parseInt(trigger.condition);
      
    case 'areaCategory':
      const category = vesselConfig.areaCategory || vesselConfig.category || 6;
      if (trigger.condition.includes('-')) {
        const [min, max] = trigger.condition.split('-').map(n => parseInt(n));
        return category >= min && category <= max;
      }
      return category <= parseInt(trigger.condition);
      
    case 'speed':
      const speed = vesselConfig.maxSpeed || 0;
      if (trigger.condition.startsWith('>')) {
        return speed > parseInt(trigger.condition.slice(1));
      }
      return speed >= parseInt(trigger.condition);
      
    case 'operations':
      return vesselConfig.operations?.includes(trigger.condition);
      
    case 'voyageType':
      return vesselConfig.voyageType === trigger.condition;
      
    case 'timeOfDay':
      // This would be checked at runtime
      return false; // Will be handled by the component
      
    default:
      return false;
  }
}